import { Stack } from "expo-router";
import React from "react";

export default function AdminLayout() {
  return (
    // We define these here - but also in "index" screen - so we can navigate to them from "index"
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "Admin" }} />
      <Stack.Screen name="user-admin" options={{ title: "Users" }} />
      <Stack.Screen name="magic-link-admin" options={{ title: "Magic Links" }} />
      <Stack.Screen name="group-admin" options={{ title: "Groups" }} />
      <Stack.Screen name="contact-admin" options={{ title: "Contacts" }} />
      <Stack.Screen name="media-admin" options={{ title: "Media" }} />
      <Stack.Screen name="memory-admin" options={{ title: "Memories" }} />
      <Stack.Screen name="place-admin" options={{ title: "All Places" }} />
      <Stack.Screen name="anchor-admin" options={{ title: "All Anchors" }} />
      <Stack.Screen name="share-admin" options={{ title: "All Shares" }} />
      <Stack.Screen name="migration-admin" options={{ title: "Migrations" }} />
      <Stack.Screen name="crashlytics-admin" options={{ title: "Crashlytics" }} />
      <Stack.Screen name="feature-toggles" options={{ title: "Feature Toggles" }} />
      <Stack.Screen name="workflow-admin" options={{ title: "All Workflows" }} />
      <Stack.Screen name="metrics-admin" options={{ title: "Platform Metrics" }} />
      <Stack.Screen name="activity-admin" options={{ title: "All Activity" }} />
      <Stack.Screen name="design" options={{ title: "Design Sandbox" }} />
      <Stack.Screen name="test" options={{ title: "Test" }} />
    </Stack>
  );
}
